import {Component, OnInit, ViewChild} from '@angular/core';
import {AbastecimentosViewModel} from "../model/abastecimentos-view-model";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort} from "@angular/material/sort";
import {LoginModel} from "../../model/login.model";
import {NomeCombustivel} from "../../precos-combustiveis/model/AlteracaoCombustivel";
import {SubfrotaService} from "../subfrota.service";
import {AuthenticationService} from "../../services/authentication.service";
import {Router} from "@angular/router";
import {AprovacaoCorrecaoKm} from "../model/aprovacao-correcao-km";
import {SnackBarService} from "../../services/snack-bar-service.service";

@Component({
  selector: 'app-subfrota-aprovacao-abastecimento-editado',
  templateUrl: './subfrota-aprovacao-abastecimento-editado.component.html',
  styleUrls: ['./subfrota-aprovacao-abastecimento-editado.component.scss']
})
export class SubfrotaAprovacaoAbastecimentoEditadoComponent implements OnInit {

  public loading = 0;
  public abastecimento?: AbastecimentosViewModel;
  public displayedColumns!: string[];
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  usuario !: LoginModel | undefined;
  listaCombustiveis: NomeCombustivel[] = [];

  private urlAnterior: string =  '/subfrota/relatorio-abastecimentos-editados'

  constructor(
    private router: Router,
    private subFrotaService: SubfrotaService,
    private snackBar: SnackBarService,
    private authenticationService: AuthenticationService,

  ) {
    // Inicialização do Filtro e das colunas do Material Table que precisam ficar no Constructor
    this.displayedColumns = [ 'flgEditavel', 'nomFantasiaPosto', 'dscPlaca', 'datAbastecimento', 'indCombustivel', 'qtdVolume', 'vlrUnitario', 'vlrTotal', 'numKm',];

  }

  ngOnInit(): void {
    this.loading = 1;
    this.usuario = this.subFrotaService?.usuario;

    // Verifica se o guid do usuário é ou continua válido.
    this.authenticationService.validate(this.subFrotaService?.usuario?.retorno?.guid ?? '')
      .then((dados => {
        if (!dados.sucesso) {
          this.snackBar.flashMessage(this.authenticationService.msgSessaoExpirada, ['snackbar-error'], 'Fechar', 0);
          this.usuario = undefined;
          this.router.navigateByUrl(this.urlAnterior);
        }
      }))
      .catch(() => {
        this.snackBar.flashMessage(this.authenticationService.msgSessaoExpirada, ['snackbar-error'], 'Fechar', 0);
      })
      .finally(() => {
        this.abastecimento = history.state.abastecimento;
        this.listaCombustiveis = history.state.combustiveis;

        if(this.abastecimento == undefined || this.listaCombustiveis == undefined)
          this.router.navigateByUrl(this.urlAnterior);

        this.loading = 0;
      });



  }

  mostrarNomeCombustivel(indCombustivel: string) {
    const comb = this.listaCombustiveis.find(x=> x.descricaoCombustivel.trim().toUpperCase() === indCombustivel.trim().toUpperCase());
    return comb?.combustivel == undefined ? '' : comb.combustivel;
  }

  public cancelar(): void{
    this.router.navigateByUrl(this.urlAnterior);
  }

  salvar() {
    this.salvarAbastecimentoEditado();
  }

  private salvarAbastecimentoEditado() {
    const abastecimentoParaSalvar : AprovacaoCorrecaoKm = {
      guid : this.subFrotaService?.usuario?.retorno?.guid ?? '',
      codAbastecimento: this.abastecimento?.codAbastecimento
    }

     this.subFrotaService.aprovarAbastecimentoEditado(abastecimentoParaSalvar)
       .subscribe(result =>{
         if(result.sucesso){
           this.snackBar.flashMessage(`Abastecimento ${abastecimentoParaSalvar.codAbastecimento} salvo com sucesso!`, ['snackbar-success'], 'Fechar', 0);
           this.router.navigateByUrl(this.urlAnterior);
         }
         else {
           const msgs = result.mensagens.join('\n');
           this.snackBar.flashMessage(msgs, ['snackbar-error'], 'Fechar', 0);
           // this.snackBar.flashMessage(`Abastecimento ${abastecimentoParaSalvar.codAbastecimento} não salvo!`, ['snackbar-error'], 'Fechar', 0);
         }
       });

  }
}
